import { SRS } from '@datum-group/isogd-openapi/lib';
import {
  action,
  computed,
  makeObservable,
  observable,
  runInAction,
} from 'mobx';
import { Services } from '@project/API';

export interface SRSOption {
  srid: string;
  auth_name: string;
  description?: string;
  proj4text: string;
}

export class SRSSelector {
  @observable private _value?: string = undefined;
  @observable private _options: SRSOption[] = [];
  @observable private _isLoading = false;
  @observable private _optionsErrorMsg?: string = undefined;
  @observable private _valueErrorMsg?: string = undefined;
  private _services: Services;

  constructor(services: Services) {
    this._services = services;

    makeObservable(this);

    this._loadOptions();
  }

  @computed get value() {
    return this._value;
  }

  @computed get options() {
    return [...this._options];
  }

  @computed get isLoading() {
    return this._isLoading;
  }

  @computed get optionErrorMsg() {
    return this._optionsErrorMsg;
  }

  @computed get valueErrorMsg() {
    return this._valueErrorMsg;
  }

  @action setOption = (srid?: string) => {
    this._valueErrorMsg = undefined;
    if (srid === undefined) {
      this._value = undefined;

      return;
    }

    const option = this._options.find((option) => option.srid === '' + srid);

    if (!option) throw new Error('Не найдена опция в списке опций');

    this._value = option.auth_name + ':' + option.srid;
  };

  @action setValue = (srid: string) => {
    this._value = srid;
  };

  @action private async _loadOptions() {
    this._isLoading = true;
    this._optionsErrorMsg = undefined;
    try {
      const resp = await this._services.srs.apiSrsActive(undefined, 0);

      runInAction(
        () => (this._options = this._createOptions(resp.data.results)),
      );
    } catch (e) {
      runInAction(
        () => (this._optionsErrorMsg = 'Не удалось загрузить список проекций'),
      );
    } finally {
      runInAction(() => (this._isLoading = false));
    }
  }

  private _createOptions(srsList: SRS[]): SRSOption[] {
    return srsList.map((srs) => {
      const description =
        typeof srs.description === 'string' ? srs.description : '' + srs.srid;

      return {
        description,
        srid: '' + srs.srid,
        auth_name: srs.auth_name,
        proj4text: srs.proj4text,
        auth_srid: srs.auth_srid,
      };
    });
  }
}
